import "./Css/StyleStor.css";
import { BiMessageAltEdit, BiMessageSquareEdit } from "react-icons/bi";
import { AiFillMail } from "react-icons/ai";
import { FiMessageSquare } from "react-icons/fi";
import { MdDownload } from "react-icons/md";
import { MdUpdate } from "react-icons/md";
import { MdUpload } from "react-icons/md";
import { BsChat, BsFillChatTextFill } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { addCommas } from "@persian-tools/persian-tools";

export function ProductsOrder({ data, index, updateSelectedItem, pageType }) {
  // timestamo
  const timestampToDate = (time) => {
    if (time != "") {
      const a = time * 1000;
      const date = new DateObject({ date: a, calendar: persian });
      return date.format();
    }
  };

  const statusPreview = (status) => {
    switch (status) {
      case 0:
        return "ثبت شده";
        break;
      case 1:
        return "ارسال شده";

        break;
      case 2:
        return "لغو شده";

        break;
      case 3:
        return "حذف شده";

        break;
      default:
        return "نامعلوم";
        break;
    }
  };
  const typeOfOrdersPreview = (status) => {
    switch (status) {
      case 0:
        return " افلاین";
        break;
      case 1:
        return "انلاین ";
        break;
      default:
        return "نامعلوم";
        break;
    }
  };
  let specialProducts = [],
    moreProducts = [];
  for (let index = 0; index < data.items.length; index++) {
    if (index < 4) {
      specialProducts.push(
        <ProductsItem
          index={index}
          img={data.items[index].url}
          title={data.items[index].title}
          price={data.items[index].main_price}
          url={data.items[index].url}
        ></ProductsItem>
      );
    } else {
      moreProducts.push(
        <ProductsItem
          index={index}
          img={data.items[index].url}
          title={data.items[index].title}
          price={data.items[index].main_price}
          url={data.items[index].url}
          isMore={true}
        ></ProductsItem>
      );
    }
  }
  if (pageType == "user") {
    return (
      <div>
        <div className=" mt-4 mx-4 order-item">
          <div className="d-flex flex-wrap justify-content-flex-start mx-0 p-3  ">
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                تاریخ ثبت :
              </span>
              <span style={{ color: "#fa0520" }}>
                {timestampToDate(data.mtm)}{" "}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                تاریخ پرداخت :
              </span>
              <span style={{ color: "#fa0520" }}>
                {timestampToDate(data.complate_pay_tm)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                تاریخ ارسال :
              </span>
              <span style={{ color: "#fa0520" }}>
                {" "}
                {timestampToDate(data.sendtm)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                شماره سفارش :
              </span>
              <span style={{ color: "#fa0520" }}> {data.order_code}</span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                نوع سفارش :
              </span>
              <span style={{ color: "#fa0520" }}>
                {typeOfOrdersPreview(+data.order_type)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                وضعیت سفارش :
              </span>
              <span style={{ color: "#fa0520" }}>
                {statusPreview(+data.main_status)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070" }}>مبلغ کل </span>
              <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
              <span style={{ marginRight: "10px", color: "#fa0520" }}>
                {addCommas(data.total_amount.toLocaleString())}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070" }}> مانده حساب </span>
              <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
              <span style={{ marginRight: "10px", color: "#fa0520" }}>
                {addCommas(
                  data.total_amount - data.total_discount - data.paid_amount
                )}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-start mx-0 p-2 flex-wrap">
            {specialProducts}
          </div>

          <div
            className="d-flex justify-content-center align-items-center"
            style={{ alignItems: "center !important", width: "100%" }}
          >
            <div
              className="accordion"
              id="accordionExample "
              style={{ width: "100%" }}
            >
              <div>
                {/* <h2 className="accordion-header" id="headingOne">
                 
                </h2> */}
                <div
                  id={`collapseOne-${index}`}
                  className="accordion-collapse collapse "
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body d-flex flex-wrap ">
                    {moreProducts}
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-flex-start mt-4">
            <span style={{ marginRight: "40px", fontWeight: "bold" }}>
              توضیحات
            </span>
            <span style={{ marginLeft: "15px", marginRight: "15px" }}>:</span>
            <span>{data.despription}</span>
          </div>
          <div
            className="d-flex justify-content-between align-items-baseline admin-button"
            style={{ height: "auto" }}
          >
            {/* message icon */}
            <span
              data-tip="پیام"
              onClick={() => {
                updateSelectedItem(data);
              }}
              className="buttons"
              style={{
                color: "#457B9D",
                textDecoration: "none",
                marginRight: "15px",
                marginLeft: "7px",
                fontSize: "25px",
              }}
              data-bs-toggle="modal"
              data-bs-target="#StatusReportModal"
            >
              {/* {data2.Statusreport}  */}
              {data.chats[data.chats.length - 1] &&
              data.chats[data.chats.length - 1].type == "0" ? (
                // data.chat[0].type == "user"
                // <AiFillMail></AiFillMail>
                <span
                  data-tip="پیام"
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    marginLeft: "7px",
                    fontSize: "25px",
                  }}
                  className="cursor-pointer"
                >
                  <div className="position-relative ">
                    {/* <BsChat></BsChat> */}
                    <BsFillChatTextFill></BsFillChatTextFill>
                    <ReactTooltip></ReactTooltip>

                    <div className=" rounded-pill position-absolute blink-message"></div>
                  </div>
                </span>
              ) : (
                // <BsChat></BsChat>
                <div>
                  <BsFillChatTextFill></BsFillChatTextFill>
                  <ReactTooltip></ReactTooltip>
                </div>
              )}
              {/* {/* {MessageIcon()} */}
            </span>
            {/* accordion button */}
            <div
              data-bs-toggle="collapse"
              data-bs-target={`#collapseOne-${index}`}
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <div className="d-flex justify-content-center align-items-center">
                <div>
                  <a
                    href="#"
                    style={{
                      color: "#457B9D",
                      textDecoration: "none",
                      fontSize: "15px",
                    }}
                    className="mx-auto"
                  >
                    جزئیات بیشتر
                  </a>
                </div>
              </div>
            </div>
            {/* paid modal */}
            <div className="d-flex justify-content-end align-items-center paid-button">
              {data.total_amount - data.total_discount - data.paid_amount >
              0 ? (
                <span
                  data-tip=" تکمیل وجه"
                  style={
                    {
                      // marginLeft: "15px",
                    }
                  }
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      backgroundColor: "#10451d",
                      color: "white",
                      border: "none",
                      borderRadius: "15px",
                      padding: "8px 20px ",
                      fontSize: "18px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#ComolatePriceModal"
                    onClick={() => {
                      updateSelectedItem(data);
                    }}
                  >
                    تکمیل وجه
                  </button>
                  <span
                    onClick={() => {
                      updateSelectedItem(data);
                    }}
                    style={{
                      color: "#457B9D",
                      textDecoration: "none",
                      fontSize: "50px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#StatusReportModal"
                  ></span>
                </span>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className=" mt-4 mx-4 order-item">
          <div className="d-flex flex-wrap justify-content-flex-start mx-0 p-3  ">
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                تاریخ ثبت :
              </span>
              <span style={{ color: "#fa0520" }}>
                {/* {data.submitDate} */}
                {timestampToDate(data.mtm)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                تاریخ پرداخت :{" "}
              </span>
              <span style={{ color: "#fa0520" }}>
                {/* {data.paymentDate} */}
                {timestampToDate(data.complate_pay_tm)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                تاریخ ارسال :{" "}
              </span>
              <span style={{ color: "#fa0520" }}>
                {/* {data.sendDate} */}
                {timestampToDate(data.sendtm)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                شماره سفارش :
              </span>
              <span style={{ color: "#fa0520" }}>
                {/* {data.OrderNumber} */}
                {data.order_code}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                نوع سفارش :
              </span>
              <span style={{ color: "#fa0520" }}>
                {/* {typeOfOrdersPreview(data.TypeOfOrders)} */}
                {typeOfOrdersPreview(+data.order_type)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                وضعیت سفارش :
              </span>
              <span style={{ color: "#fa0520" }}>
                {/* {statusPreview(data.main_status)} */}
                {statusPreview(+data.main_status)}
              </span>
            </div>

            <div style={{ marginRight: "32px", marginTop: "10px" }}>
              <span style={{ color: "#707070" }}>مبلغ کل </span>
              <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
              <span style={{ marginRight: "10px", color: "#fa0520" }}>
                {/* {data.price.toLocaleString()} */}
                {addCommas(data.total_amount)}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070" }}> مانده حساب </span>
              <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
              <span style={{ marginRight: "10px", color: "#fa0520" }}>
                {/* {data.debtAmount.toLocaleString()} */}
                {addCommas(
                  data.total_amount - data.total_discount - data.paid_amount
                )}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>
                نام کاربر :
              </span>
              <span style={{ color: "#555761" }}>
                {/* {data.NameUser}  */}
                {`${data.rescipient_fname} ${data.rescipient_lname}`}
              </span>
            </div>
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <span style={{ color: "#707070", fontSize: "18px" }}>ادرس :</span>
              <span style={{ color: "#555761" }}>
                {/* {data.address} */}
                {data.rescipient_address}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-start mx-0 p-2 flex-wrap">
            {specialProducts}
          </div>
          {/* <div className="d-flex justify-content-flex-start mt-4">
            <span style={{ marginRight: "40px", fontWeight: "bold" }}>
              توضیحات
            </span>
            <span style={{ marginLeft: "15px", marginRight: "15px" }}>:</span>
            <span>{data.description}</span>
          </div> */}

          <div className=" d-flex  mt-3 p-4">
            <div
              style={{ width: "65%", textAlign: "left", alignSelf: "center" }}
              class="d-flex justify-content-end align-items-center"
            >
              <div className="accordion" id="accordionExample">
                <div>
                  <h2 className="accordion-header" id="headingOne"></h2>
                </div>
              </div>
            </div>
          </div>

          <div
            id={`collapseOne-${index}`}
            className="accordion-collapse collapse "
          >
            <div className="accordion-body d-flex flex-wrap ">
              {moreProducts}
              <div></div>
            </div>
            <div className="ms-5">
              ثبت کننده سفارش:
              <span>{`${data.user_muid.fname} ${data.user_muid.lname}`}</span>
            </div>
          </div>
          {/* {data.link != "" ? (
            <div className="d-flex justify-content-flex-start mt-4">
              <span style={{ marginRight: "40px", whiteSpace: "nowrap" }}>
                لینک دانلود فایل
              </span>
              <span style={{ marginLeft: "15px", marginRight: "15px" }}>:</span>
              <span>
                <a href={data.link} target="_blank">
                  link
                </a>
              </span>
            </div>
          ) : (
            ""
          )} */}
          <div className="d-flex justify-content-flex-start mt-4">
            <span style={{ marginRight: "40px", fontWeight: "bold" }}>
              توضیحات
            </span>
            <span style={{ marginLeft: "15px", marginRight: "15px" }}>:</span>
            <span>{data.despription}</span>
          </div>
          <div
            class="d-flex justify-content-between align-items-center admin-button"
            style={{ height: "auto" }}
          >
            {/* message/ edit button */}
            <div className="d-flex align-items-center justify-content-start buttons">
              {/* message icon */}
              <div
                data-tip="پیام"
                onClick={() => {
                  updateSelectedItem(data);
                }}
                style={{
                  color: "#457B9D",
                  textDecoration: "none",
                  marginRight: "10px",
                  marginLeft: "7px",
                  fontSize: "25px",
                }}
                data-bs-toggle="modal"
                data-bs-target="#StatusReportModal"
              >
                {/* {data2.Statusreport}  */}
                {data.chats[data.chats.length - 1] &&
                data.chats[data.chats.length - 1].type == "1" ? (
                  <span
                    data-tip="پیام"
                    style={{
                      position: "relative",
                      marginRight: "10px",
                      marginLeft: "7px",
                      fontSize: "25px",
                    }}
                  >
                    <div className="position-relative cursor-pointer">
                      {/* <BsChat></BsChat> */}
                      <BsFillChatTextFill></BsFillChatTextFill>
                      <div className=" rounded-pill position-absolute blink-message"></div>
                    </div>
                  </span>
                ) : (
                  // data.chat[0].type == "user"
                  // <AiFillMail></AiFillMail>
                  <BsFillChatTextFill></BsFillChatTextFill>
                  // <BsChat></BsChat>
                )}
                {/* {/* {MessageIcon()} */}
              </div>
              {/* edit icon */}
              <div
                data-tip=" ویرایش سفارشات"
                onClick={() => {
                  updateSelectedItem(data);
                }}
                style={{
                  marginRight: "10px",
                  marginLeft: "7px",
                  fontSize: "25px",
                  color: "#457B9D",
                }}
                data-bs-toggle="modal"
                data-bs-target="#UpdateOrderModal"
                className="cursor-pointer"
              >
                {/* <BiMessageAltEdit></BiMessageAltEdit> */}
                <BiMessageSquareEdit />
                <ReactTooltip />
              </div>
            </div>
            {/* accordion button */}
            <div
              data-bs-toggle="collapse"
              data-bs-target={`#collapseOne-${index}`}
              aria-expanded="true"
              aria-controls="collapseOne"
              className=""
            >
              <div className="d-flex align-items-center justify-content-center me-2">
                <a
                  href="#"
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                  className="mx-auto"
                >
                  جزئیات بیشتر
                </a>
              </div>
            </div>
            {/* paid modal */}
            <div className="d-flex align-items-center justify-content-end paid-button ">
              {data.total_amount - data.total_discount - data.paid_amount >
              0 ? (
                <span
                  data-tip="  افزودن تکمیل وجه "
                  // style={{
                  //   marginLeft: "15px",
                  // }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      backgroundColor: "#10451d",
                      color: "white",
                      border: "none",
                      borderRadius: "15px",
                      padding: "8px 20px ",
                      fontSize: "18px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#ComolatePriceModal"
                    onClick={() => {
                      updateSelectedItem(data);
                    }}
                  >
                    افزودن تکمیل وجه
                  </button>
                  <span
                    onClick={() => {
                      updateSelectedItem(data);
                    }}
                    style={{
                      color: "#457B9D",
                      textDecoration: "none",
                      fontSize: "50px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#StatusReportModal"
                  ></span>
                </span>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function ProductsItem({ img, title, price, index, isMore, url }) {
  return (
    <div className=" col-3  col-6 col-md-4 col-lg-3 col-child text-center  ">
      {isMore && (
        <div
          style={{
            // borderTop: "2px solid #dcdcdc",
            width: "220px",
            margin: "5px 0px",
          }}
        ></div>
      )}
      <div className="d-flex justify-content-evenly">
        <div className=" ">
          <div className="box-img">
            <img
              src={`http://grc.tatdemo.ir/${img}`}
              style={{ height: "150px", width: "150px" }}
            ></img>
          </div>
          <div className="box-title mt-3 px-1" style={{ height: "45px" }}>
            <p
              style={{ color: "#011c40", fontWeight: "bold" }}
              className="two-line"
            >
              {title}
            </p>
          </div>
          <div>
            <p style={{ color: "#fa0520", height: "25px" }}>
              {price && `${addCommas(price)}تومان`}
            </p>
          </div>
          {/* {url != "" ? ( */}
          {/* <div className="d-flex justify-content-flex-start mt-4"> */}
          {/* <span style={{ marginRight: "40px", whiteSpace: "nowrap" }}>
                لینک دانلود فایل
              </span> */}
          {/* <span style={{ marginLeft: "15px", marginRight: "15px" }}>:</span> */}
          {/* <span className="mx-auto"> */}
          {/* <a href={`http://grc.tatdemo.ir/${url}`} target="_blank"> */}
          {/* دانلود فایل مشتری */}
          {/* </a> */}
          {/* </span> */}
          {/* </div> */}
          {/* ) : ( */}
          {/* "" */}
          {/* )} */}
        </div>

        <div
          style={{
            borderLeft: "2px solid #dcdcdc",
            height: "220px",
          }}
        ></div>
      </div>
    </div>
  );
}
